import React, { Component } from 'react';
import { Modal } from 'antd';
import IdleTimer from 'react-idle-timer';
const { confirm } = Modal;

export class SessionIdleTimer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            stopOnIdle: true
        }
        this.idleTimer = null
        this.handleOnAction = this.handleOnAction.bind(this)
        this.handleOnActive = this.handleOnActive.bind(this)
        this.handleOnIdle = this.handleOnIdle.bind(this)
    }

    showConfirm = (props, idleTimer) => {
        let secondsToGo = 60;
        let continueSession = false;
        const modal = Modal.warning({
            title: <h1>Your session will expire!</h1>,
            content: <p><p>you will be logged out in {secondsToGo} seconds</p>
                <p>click continue if you'd like to stay.</p></p>,
            okText: 'Logout',
            cancelText: 'Continue',
            okCancel() {
                console.log('inside okCancel!');
            },

            onOk() {
                props.userSignOut();
                clearInterval(timer);
                clearTimeout(setTimeouter)
            },
        });


        const timer = setInterval(() => {
            secondsToGo -= 1;
            modal.update({
                content: <p><p>you will be logged out in {secondsToGo} seconds</p>
                    <p>click continue if you'd like to stay.</p></p>,
                okText: 'Logout',
                cancelText: 'Continue',
                okCancel() {
                    console.log('inside okCancel!');
                },
                onCancel() {
                    idleTimer.reset();
                    Modal.destroyAll();
                    continueSession = true;
                },
                onOk() {
                    props.userSignOut()
                    clearInterval(timer);
                    clearTimeout(setTimeouter)
                }
            });
        }, 1000);
        const setTimeouter = setTimeout(() => {
            clearInterval(timer);
            modal.destroy();
            if (!continueSession) {
                props.userSignOut();
            }

        }, secondsToGo * 1000);
    }

    componentWillUnmount() {
        Modal.destroyAll();
    }

    render() {
        return (
            <div>
                <IdleTimer
                    startOnMount={true}
                    ref={ref => { this.idleTimer = ref }}
                    // timeout={1000 * 60 * 30}
                    timeout={10800000}
                    onActive={this.handleOnActive}
                    onIdle={this.handleOnIdle}
                    onAction={this.handleOnAction}
                    debounce={250}
                    // stopOnIdle={true}
                    crossTab={{
                        emitOnAllTabs: true
                    }}
                />
                {/* your app here */}
            </div>
        )
    }

    handleOnAction(event) {
        this.idleTimer.reset();
    }

    handleOnActive(event) {
        // this.idleTimer.reset();
    }

    handleOnIdle(event) {
        this.showConfirm(this.props, this.idleTimer);
    }
}


export default SessionIdleTimer;
